import * as React from 'react'
import { useSession } from 'next-auth/react'
import * as DevvAPI from 'utils/devv-api'
import devvSdk from 'utils/devv-sdk'
import { User } from 'types/types'

const useAuth = () => {
    const [loading, setLoading] = React.useState(true)
    const session = useSession()

    React.useEffect(() => {
        if (session?.data?.accessToken) {
            DevvAPI.setAuthToken(session.data.accessToken)
            devvSdk.setAuthData({ token: session.data.accessToken, userId: (session?.data?.user as User)._id })
            setLoading(false)
        }
    }, [session])

    return {
        status: loading ? 'loading' : session?.status,
        user: (session?.data?.user as User) || null,
        userId: session?.data?.user ? (session?.data?.user as User)._id : null,
        token: session?.data?.accessToken || null,
    }
}

export default useAuth
